export const SET_MSG_LIST = 'SET_MSG_LIST'

export const SET_NOTIFY_COUNT = 'SET_NOTIFY_COUNT'

export const SET_UNREAD_MSG = 'SET_UNREAD_MSG'

export const SET_UNREAD_LIKE_MSG = 'SET_UNREAD_LIKE_MSG'

export const SET_UNREAD_COMMENT_MSG = 'SET_UNREAD_COMMENT_MSG'

export const SET_UNREAD_WALLET_MSG = 'SET_UNREAD_WALLET_MSG'

export const SET_UNREAD_FOLLOW_MSG = 'SET_UNREAD_FOLLOW_MSG'

export const SET_TOKEN = 'SET_TOKEN'

export const SET_USER = 'SET_USER'

export const SET_MEMBER_EXT = 'SET_MEMBER_EXT'

export const SET_INFO_COMPLETERATE = 'SET_INFO_COMPLETERATE'

export const SET_SETTING = 'SET_SETTING'

export const SET_CITYS = 'SET_CITYS'

export const SET_EDIT_ADDRESS = 'SET_EDIT_ADDRESS'

export const SET_REGISTER = 'SET_REGISTER'

export const SET_FORGET = 'SET_FORGET'

export const SET_UPDATE_PHONE = 'SET_UPDATE_PHONE'

export const SET_IS_COMMUNICATE = 'SET_IS_COMMUNICATE'

export const SET_VIDEO = 'SET_VIDEO'

export const SET_SOCIAL_DATA = 'SET_SOCIAL_DATA'

export const SET_MY_POSTION = 'SET_MY_POSITION'

export const SET_UPLOAD_TASK = 'SET_UPLOAD_TASK'

export const SET_PRODUCT = 'SET_PRODUCT'

export const SET_ORDER = 'SET_ORDER'

export const SET_USER_INFO = 'SET_USER_INFO'

export const SET_REWARD = 'SET_REWARD'

export const ADD_MSG = 'ADD_MSG'

export const SET_NULL_MSG = 'SET_NULL_MSG'

export const CONCAT_MSG_LIST = 'CONCAT_MSG_LIST'

export const SET_CHAT_UID = 'SET_CHAT_UID'

export const SET_READ_ARTICLE = 'SET_READ_ARTICLE'

export const SET_CHAT_NOTIYFY = 'SET_CHAT_NOTIFY'

export const DELETE_CHAT_NOTIYFY = 'SET_CHAT_NOTIFY'



// WEBPACK FOOTER //
// ./src/store/mutation-types.js